import { IPlatformPageSection, PlatformPageTextGridItem } from '@/shared/types/platform-pages';
import Image from 'next/image';

interface IProps {
  content: IPlatformPageSection;
}

const Grid = ({ content }: IProps) => (
  <div className="section-inner grid">
    {(content.textGridItems ?? []).map((gridItem: PlatformPageTextGridItem) => {
      return (
        <div key={gridItem.title} className="grid-item">
          <Image className="grid-item-icon" src={gridItem.icon} width={24} height={24} alt={gridItem.title} />
          <h3 className="grid-item-title" style={{ color: content.titleColor }}>
            {gridItem.title}
          </h3>
          <p className="grid-item-description" style={{ color: content.descriptionColor }}>
            {gridItem.description}
          </p>
        </div>
      );
    })}
  </div>
);

export default Grid;
